/**
 * 处理日期时间数据
 */
function handleTimeDateValue(timeValue: string): Date | null {
    let returnValue = null;
    // 解析 年月日 时分秒 对应值
    const timeValueArr = timeValue.match(/^(\d{4})[-/]?(\d+)?[-/]?(\d*)[Tt\s]*(\d+)?:?(\d+)?:?(\d+)?[.:]?(\d+)?$/);
    if (timeValueArr) {
        // 创建新 Date
        returnValue = new Date(
            Number(timeValueArr[1]),
            Number(timeValueArr[2]) - 1 || 0,
            Number(timeValueArr[3]) || 1,
            Number(timeValueArr[4]) || 0,
            Number(timeValueArr[5]) || 0,
            Number(timeValueArr[6]) || 0,
        );
    }
    return returnValue;
}

export const appUtil = {
    handleTimeDateValue,
};
